export default {
    faq: require('./faq').default,
    home: require('./home').default,
    auth: require('./auth').default,
    city: require('./city').default,
    admin: require('./admin').default,
    chat: require('./chat').default,
    bonus: require('./bonus').default,
    client: require('./client').default,
    master: require('./master').default,
    setting: require('./setting').default,
    payment: require('./payment').default,
    coworking: require('./coworking').default,
    instruction: require('./instruction').default,
    notification: require('./notification').default,
    specialization: require('./specialization').default,
}
